import genActTypes from '../core/types';

const types = genActTypes('posts');

export default types;
